"use client";

import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { howItWorks as data } from "@/lib/data/capabilities-narrative-engineering";

const stepAccents = [
  "var(--color-crimson)",
  "var(--color-purple)",
  "var(--color-cyan)",
  "var(--color-emerald)",
  "var(--color-amber)",
  "var(--color-denim)",
  "var(--color-violet)",
] as const;

export function HowItWorks() {
  return (
    <Section id="how-it-works" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-96 w-96 rounded-full bg-[var(--color-emerald)] opacity-15 blur-[140px]" />
      </div>

      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 relative">
          <div
            className="hidden lg:block absolute top-0 bottom-0 left-[27px] w-px"
            style={{
              background: `linear-gradient(180deg, transparent, color-mix(in oklch, var(--color-crimson) 50%, transparent) 10%, color-mix(in oklch, var(--color-purple) 50%, transparent) 30%, color-mix(in oklch, var(--color-cyan) 50%, transparent) 50%, color-mix(in oklch, var(--color-emerald) 50%, transparent) 70%, color-mix(in oklch, var(--color-amber) 50%, transparent) 90%, transparent)`,
            }}
            aria-hidden
          />

          <div className="space-y-10">
            {data.steps.map((step, i) => {
              const accent = stepAccents[i % stepAccents.length]!;
              return (
                <Reveal key={step.number} delay={i * 80}>
                  <div className="relative flex gap-6 items-start">
                    <div className="shrink-0 relative">
                      <div
                        className="grid place-items-center h-14 w-14 rounded-2xl glass relative z-10"
                        style={{
                          boxShadow: `0 0 0 4px rgb(var(--bg)), inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                        }}
                      >
                        <span className="text-xs font-bold tracking-wider" style={{ color: accent }}>
                          {step.number}
                        </span>
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <div className="eyebrow-tiny" style={{ color: accent }}>
                        Step {step.number}
                      </div>
                      <h3 className="mt-1">{step.title}</h3>
                      <p className="mt-3 text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed max-w-3xl">
                        {step.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Container>
    </Section>
  );
}
